import React, { useEffect } from "react";
import { Spinner } from "@sapphire-react/lab";
import * as styles from './LogoutComponent.style'
import { PostLegacyLogout } from "../../api/ApiCalls";
import { Variables } from "../../api/utils/endpoints";
import { useLocation, useNavigate, useParams } from "react-router-dom";

//function to validate if the given string is a valid url and can be redirected to.
function isValidUrl(url: string): boolean {
  try {
    new URL(url);
    return true;
  } catch (error) {
    return false;
  }
}
const HomeComponent = () => {
  //getting the language paramter in the url
  var { language } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const allowedLanguages = Variables.allowedLanguageArray;
  const defaultLanguage = Variables.finnishLanguageCode;
  //Look for Redirect uri in query parameter
  const searchParams = new URLSearchParams(location.search);
  const redirect_uri = searchParams.get(Variables.RedirectUriQueryParameter);
  useEffect(() => {
    //If no redirect uri is present, go to error screen
    if (!redirect_uri || !isValidUrl(redirect_uri)) {
      console.log("No Redirect Uri provided or incorrect URL format");
      navigate(`/${language}/signin/error`, { replace: true })
      return;
    }
    //If no language or any other language is given, go to the default language
    if (!language || !allowedLanguages.includes(language)) {
      navigate(`/${defaultLanguage}/logout${location.search}`, { replace: true });
      return;
    }
    else {
      const CallLegacyLogout = async (RedirectUrl: string) => {
        await PostLegacyLogout(RedirectUrl);
      }
      //Call the /logout API to logout of all sessions
      CallLegacyLogout(redirect_uri);
    }
  }, [language, navigate, location.search, allowedLanguages, defaultLanguage, redirect_uri]);
  return (
    <div style={styles.mainDiv}>
      <Spinner aria-label="Loading..." size="xl" margin="auto" />
    </div>
  );
};


export default HomeComponent;